import { render, staticRenderFns } from "./DifficultyScore.vue?vue&type=template&id=3657d6b1&scoped=true&"
import script from "./DifficultyScore.vue?vue&type=script&lang=js&"
export * from "./DifficultyScore.vue?vue&type=script&lang=js&"
import style0 from "./DifficultyScore.vue?vue&type=style&index=0&id=3657d6b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3657d6b1",
  null
  
)

export default component.exports